import React from "react";
import {useSelector} from "react-redux";
import type {RootState} from "../../stores";
import {app} from "../../modules/config.ts";

const Loader: React.FC = () => {
  const { isOpen } = useSelector((state: RootState) => state.preloader);

  if (!isOpen) return null;

  return (
    <div className="loading">
      <img src={`${app.imagePath}/favicon.png`} alt="로고" className="loading-logo"/>
    </div>
  );
};

export default Loader;